<template>
  <album>
    <div class="album-lists">
      <transition-group name="list" mode="out-in" tag="div" class="lists">
        <div
          class="item"
          v-for="(item, index) in albumLists"
          :key="index + 'albumLists'"
          @click="detail(item.id)"
        >
          <photo-box-1 :data="item"></photo-box-1>
        </div>
      </transition-group>
    </div>
  </album>
</template>

<script>
import PhotoBox1 from '@/components/common/PhotoBox1'
// import SortBy from '@/components/common/SortBy'
// import Language from '@/components/common/Language'
import Album from './Album'
import { getAlbum } from '@/api/album'

export default {
  name: 'album-lists',
  components: {
    Album,
    // Language,
    // SortBy,
    PhotoBox1
  },
  data() {
    return {
      albumLists: []
    }
  },
  methods: {
    detail(key) {
      this.$router.push({
        path: 'album/detail/' + key
      })
    },
    getAlbum() {
      getAlbum(this.$store.getters.userInfo.uid).then(res => {
        console.log(res)
        this.albumLists = res
      })
    }
  },
  updated() {},
  created() {
    this.getAlbum()
  }
}
</script>

<style lang="scss" scoped>
.album-lists {
  overflow-x: hidden;
  min-height: 600px;
  padding-bottom: 20px;

  .lists {
    margin-top: 20px;
    width: 1154px;
    z-index: 100;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    /*align-content: space-between;*/
    .item {
      width: 22.5%;
      height: auto;
      margin: 0 20px 68px 0;
    }

    .loading {
      margin: auto;
      position: relative;
      /*border: 1px solid red;*/
      text-align: center;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
